import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CreditService} from "./credit.service";
import {ColorThemeService} from "../common/services/color-theme.service";
import {ThemeColor} from "../common/enums/theme-color.enum";

@Component({
  selector: 'iv-live-credit',
  templateUrl: './credit.component.html',
  styleUrls: ['./credit.component.scss']
})
export class CreditComponent implements OnInit {

  @Input() isError: boolean = false;
  balance: number = 0;
  checkBox = false;
  @Input() minus: number = 0;
  @Output() proceed = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  themeColor: ThemeColor = ThemeColor.LIGHT;
  isWhiteCheckbox = true;

  public constructor(private creditService: CreditService, private colorThemeService: ColorThemeService) {
  }

  ngOnInit(): void {
    this.creditService.getCredit().subscribe(value => {
      this.balance = value;
    });
    this.themeColor = this.colorThemeService.getColorTheme();
    if (this.themeColor === ThemeColor.DARK) {
      this.isWhiteCheckbox = false;
    } else {
      this.isWhiteCheckbox = true;
    }
  }

  onProceed(): void {
    this.isError = false;
    this.proceed.emit();
  }

  onCancel(): void {
    this.isError = false;
    this.cancel.emit();
  }

}
